import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { PatientService } from '../services/patients/patient.service';

import { UsersComponent } from '../users/users.component';
import { ProviderService } from '../services/providers/provider.service';

import { Provider } from '../classes/provider'
import * as moment from 'moment';
import { Auth } from '../services/auth.service';



@Component({
  moduleId: module.id,
  selector: 'my-patients',
  templateUrl: 'patients.component.html',
  styleUrls: ['patients.component.css']
})

export class PatientsComponent extends UsersComponent {

  constructor(
    protected router: Router,
    protected patientService: PatientService,
    protected providerSevice: ProviderService,
    protected auth: Auth) { super(router, patientService, providerSevice); }

  documentNumber: string;
  name: string;
  email: string;
  fromDate: Date;
  toDate: Date;
  selectedProvider: Provider
  selectedProviderIndex: string
  hasWritePatientPermission: boolean = false;

  protected getDetailUrl(): string {

    return '/patient/' + this.selectedUser.id;
  };

  protected getCallDetailUrl(){
    return '/patient/' + this.selectedUser.id + '/calls'
  }

  protected getUserString(): string {

    return 'patient';
  };

  protected getUsersString(): string {

    return 'Patients';
  };

  add(): void { return; };

  ngOnInit(): void {
    this.getProviders()
    this.hasWritePatientPermission = this.auth.hasWritePatientPermission();
  }

  getUsers(params) {
    this.patientService.getForTable(params)
      .then(users => {

        this.users = users
        this.createdAt(this.users)
        this.haveUsers = this.users.length === this.usersPerGet
        this.noMatchesAlert = this.users.length === 0
        this.configPages();
        this.loading = false;
        this.timesSkipped++;
      })
  }


  needMoreUsers(params) {
    params['limit'] = this.usersPerGet;
    params = this.getParams(params)
    this.timesSkipped++;
    let i = 0;
    this.userService.getForTable(params)
      .then(users => {
        this.haveUsers = users.length === this.usersPerGet
        if (0 < users.length) {
          this.createdAt(users)
          for (i; i < users.length; i++) {
            this.users.push(users[i])
          }
          this.noMatchesAlert = users.length === 0
          this.configPages();
        }
      })
  }

  createdAt(users: any[]) {
    for (let i = 0; i < users.length; i++) {
      users[i].validator = users[i].validator || users[i].referenceNumber
      users[i].createdAt = users[i].createdAt.slice(8, 10) + '/' + users[i].createdAt.slice(5, 7) + '/' + users[i].createdAt.slice(0, 4) + ' ' + users[i].createdAt.slice(11, 19)
    }
  }

  updateAffiliatesData(): void {
    this.patientService.updateAffiliatesData();
  }

  getParams(params): any {
    if (this.name) params["name"] = this.name
    if (this.email) params["email"] = encodeURIComponent(this.email)
    if (this.documentNumber) params["documentNumber"] = this.documentNumber
    if (this.fromDate) params["from"] = moment(this.fromDate).format("DD-MM-YYYY")
    if (this.toDate) params["to"] = moment(this.toDate).format("DD-MM-YYYY")
    console.log(this.selectedProvider)
    if (this.selectedProvider) {
      params["provider"] = this.selectedProvider.id
    }
    if (!this.notLogged) params.loggedIn = true;
    return params
  }

  applyFilter(){
    this.noMatchesAlert = false;

    this.currentPage = 0
    this.loading = true;
    let params = {};
    params['limit'] = this.usersPerGet;
    params = this.getParams(params)

    this.userService.getForTable(params).then((users: any[]) => this.users = users)
        .then(() => {
            this.haveUsers = this.users.length === this.usersPerGet
            this.loading = false;
            this.configPages()
            this.createdAt(this.users)
            this.timesSkipped = 1;
            this.noMatchesAlert = this.users.length === 0;
        })
}

resetFilter(){
  this.documentNumber=undefined;
  this.email= undefined;
  this.fromDate=undefined;
  this.toDate= undefined;
  this.name = undefined;
  this.timesSkipped = 0
  this.currentPage = 0
  this.notLogged = true
  this.noMatchesAlert = false;
  this.getUsers({ limit: this.usersPerGet })
}


providerChanged(event){
  this.selectedProvider = this.providers[this.selectedProviderIndex]
  console.log(this.selectedProvider)
}

onRightClick(user){
  this.selectedUser = user;
  window.open(this.getDetailUrl())
}

create(){
  this.router.navigate([ '/createPatient' ]);
}

}



// WEBPACK FOOTER //
// ./src/app/patients/patients.component.ts